<template>
  <BaseAlert
    v-if="
      !hasCancelled &&
      !loading &&
      activeSubscription &&
      activeSubscription.cancelled
    "
    :text="
      t('admin.cards.subscription_cancelled.message', {
        days: dayjs(activeSubscription.endAt).diff(dayjs(), 'day')
      })
    "
    :primaryAction="
      t('admin.cards.subscription_cancelled.reactivate_subscription')
    "
    mb
    color="warning"
    @primaryAction="handleReactivateSubscription"
    v-test="'billing-subscription-cancelled-alert'"
  />
</template>

<script
  lang="ts"
  setup
>
import { useMutation } from '@vue/apollo-composable';
import dayjs from 'dayjs';
import gql from 'graphql-tag';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { flash, modal } from '@/helpers/ui';
import getCompanySubscription from './get-company-subscription';

const REACTIVATE_SUBSCRIPTION_MUTATION = gql`
  mutation reactivateSubscription($input: ReactivateSubscriptionInput!) {
    reactivateSubscription(input: $input) {
      errors {
        message
        type
      }
    }
  }
`;

const hasCancelled = ref(false);

const { t } = useI18n();
const { mutate: reactivateSubscription } = useMutation(
  REACTIVATE_SUBSCRIPTION_MUTATION,
  { variables: { input: {} } },
);

const { activeSubscription, loading } = getCompanySubscription();

const handleReactivateSubscription = () => {
  modal('confirmation', {
    message: t(
      'admin.cards.subscription_cancelled.reactivate_subscription_confirmation',
    ),
  }).then(() => {
    reactivateSubscription().then(
      ({
        data: {
          reactivateSubscription: { errors },
        },
      }) => {
        if (errors.length > 0) {
          return;
        }

        flash(t('admin.cards.subscription_cancelled.reactivation_message'));
        hasCancelled.value = true;
      },
    );
  });
};
</script>
